import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class FrontendPathInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentNav = this.router.getCurrentNavigation();
    let frontendPath = currentNav?.extractedUrl?.toString() || currentNav?.finalUrl?.toString();

    if (!frontendPath) {
      frontendPath = this.router.url;
    }

    const clonedRequest = req.clone({
      setHeaders: {
        'X-Frontend-Path': frontendPath,
      },
    });

    return next.handle(clonedRequest);
  }
}
